import React from 'react'
import ManageEntityList from './ManageEntityList'
import { Route, Switch, useParams } from 'react-router-dom';
import { useHeight } from '../../Services/HeightContext';
import ClientModal from '../Models/ClientModal';
import entities from '../../utils/entities';
import EditSupplier from '../TabbedEntity/EditSupplier';

const ManageSuppliers = ({ route }) => {
    const { supplierId } = useParams() as { supplierId: string };
    const height = useHeight();
    const routes = <Switch>
        <Route key={0} path={route + '/:supplierId/:activeKey'} render={() => <ClientModal entity={entities.supplier} route={route} itemParam='supplierId'><EditSupplier route={route} /></ClientModal>} />,
        <Route key={1} path={route + '/:supplierId'} render={() =>
            <ClientModal entity={entities.supplier} route={route} itemParam='supplierId'><EditSupplier route={route} /></ClientModal>
        } /></Switch>

    return <React.Fragment>
        <ManageEntityList routes={routes} route={route} heightOffset={0} parentHeight={height} id={supplierId} entity={{...entities.supplier as unknown as any, id: supplierId}} />

    </React.Fragment>
}

export default ManageSuppliers;

